import React from 'react';
import { SalvTab, SalvTabList, SalvTabPanel, SalvTabs } from '@salvapp/ui-components';
import PersonSignificantUpdateIndicators from './PersonSignificantUpdateIndicators';
import './SignificantUpdateIndicator.scss';
import ListSignificantFields from './ListSignificantFields';
import { InternalApiEntityType } from '../../../api-internal';
import SalvPage from '../../../common/SalvPage';
import { useSearchParams } from 'react-router';
import { SearchParamKeys } from '../../../common/searchParamKeys';
import { getConfigurationUrl } from '../../../navigation/helper';
import { ConfigurationProduct } from '../../../settings/configuration/Configuration';

const SignificantUpdateIndicators = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <SalvPage
      title={'Significant Update Indicators'}
      breadcrumb={{
        title: 'Configuration',
        to: getConfigurationUrl(ConfigurationProduct.SCREENING),
      }}
      className='significant-update-indicators'
    >
      <SalvTabs
        value={searchParams.get(SearchParamKeys.entityType) || InternalApiEntityType.PERSON}
        onChange={(entityType) => setSearchParams({ [SearchParamKeys.entityType]: entityType })}
      >
        <SalvTabList>
          <SalvTab value={InternalApiEntityType.PERSON} title={'Person'} />
          <SalvTab value={InternalApiEntityType.TRANSACTION} title={'Transaction'} />
        </SalvTabList>
        <SalvTabPanel value={InternalApiEntityType.PERSON}>
          <PersonSignificantUpdateIndicators />
        </SalvTabPanel>
        <SalvTabPanel value={InternalApiEntityType.TRANSACTION}>
          <div className='m-t-24'>
            <ListSignificantFields
              entityType={InternalApiEntityType.TRANSACTION}
              description={
                <>
                  <div className='m-b-8'>
                    Based on your Goodlisting configuration, Salv remembers matches that have been closed as false
                    positives and automatically goodlists them to avoid duplicate Alerts.
                  </div>
                  <div className='m-b-8'>
                    However, these matches are removed from the Goodlisting under two conditions:
                  </div>
                  <ul className='m-b-8'>
                    <li>
                      <span className='m-x-8'>•</span>
                      When the status of the associated Alert changes
                    </li>
                    <li>
                      <span className='m-x-8'>•</span>
                      When there’s an update in the List record
                    </li>
                  </ul>
                  <div>
                    Not all List record changes are significant enough to revoke Goodlisting; for instance, correcting a
                    typo in record’s source description. Below, you can choose which changes in the List records are
                    significant enough to remove matches from the Goodlisting.
                  </div>
                </>
              }
            />
          </div>
        </SalvTabPanel>
      </SalvTabs>
    </SalvPage>
  );
};

export default SignificantUpdateIndicators;
